import {
  LineChartOutlined,
  ApartmentOutlined,
  BankOutlined,
  BranchesOutlined,
  BarChartOutlined,
  CloudDownloadOutlined,
  PicCenterOutlined,
  SettingOutlined,
  GroupOutlined,
  AppstoreOutlined,
  AlertOutlined
} from "@ant-design/icons";

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

export const TempItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("PlantForm", "4", <BankOutlined />),
  getItem("LiveModule", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Convertor Status", "sub3"),
  ]),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    // getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    // getItem("Consumption Report", "sub7"),
  ]),
];

export const TempNavItems = [
  // { path: "/temperature-dashboard/tree-chart", id: "1" },
  // { path: "/temperature-dashboard/plant-form", id: "4" },
  { path: "/temperature-dashboard/temp-live-trends", id: "sub1" },
  { path: "/temperature-dashboard/meter-status", id: "sub2" },
  { path: "/temperature-dashboard/temperature-convertor-status", id: "sub3" },
  { path: "/temperature-dashboard/temp-comparative-report", id: "sub4" },
  { path: "/temperature-dashboard/temp-raw-data", id: "sub5" },
  { path: "/temperature-dashboard/temp-historical-trends", id: "sub6" },
  { path: "/temperature-dashboard/temp-consumption-report", id: "sub7" },
];

export const AirItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("PlantForm", "4", <BankOutlined />),
  getItem(
    "LiveModule",
    "2",
    <LineChartOutlined />
    //    [
    //   getItem("Live Trends", "sub1"),
    //   getItem("Meter Status", "sub2"),
    //   getItem("Convertor Status", "sub3"),
    // ]
  ),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption Report", "sub7"),
  ]),
];

export const AirNavItems = [
  // { path: "/air-dashboard/tree-chart", id: "1" },
  // { path: "/air-dashboard/plant-form", id: "4" },
  { path: "/air-dashboard/air-live-trends", id: "sub1" },
  { path: "/air-dashboard/meter-status", id: "sub2" },
  { path: "/air-dashboard/air-convertor-status", id: "sub3" },
  { path: "/air-dashboard/air-comparative-report", id: "sub4" },
  { path: "/air-dashboard/air-raw-data", id: "sub5" },
  { path: "/air-dashboard/air-historical-trends", id: "sub6" },
  { path: "/air-dashboard/air-consumption-report", id: "sub7" }, 
];

export const ElectricalItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("Alerts", "1", <ApartmentOutlined />),

  getItem("Dashboard", "4", <AppstoreOutlined />,[
     getItem("Dashboard", "sub18"),
  ]),
  getItem("Live Module", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    // getItem("Meter Status", "sub2"),
    // getItem("Parameter View", "sub3"),
    getItem("Status View", "sub15"),
  ]),
    getItem("Flow Meters", "12", <AlertOutlined />, [
      getItem("Temperature", "sub121"),
      
    ]),
    getItem("Alerts", "10", <AlertOutlined />, [
    getItem("Alerts", "sub101"),
    getItem("Meter Alert Configuration","sub102")

    ]),
  getItem("Reports ", "5", <BarChartOutlined />, [
    getItem("Comparative ", "sub4"),
    getItem("Consumption ", "sub7"),
    getItem("Shift Report ", "sub51"),
    getItem("Group Report", "sub11"),
    // getItem("Power Interruption", "sub12"),
  ]),
  getItem("Historical ", "1", <GroupOutlined />, [
    getItem("Plot Interval", "sub16"),
    getItem("Raw Data", "sub5"), 
    // getItem("Historical Trends", "sub6"),

  ]), 
  getItem("Manual Entry", "3", <ApartmentOutlined />, [
    getItem("Manual Data ", "sub14"),
  ]),
  getItem("Configuration", "6", <PicCenterOutlined />, [
    // getItem("Converter Config", "sub1"),
    // getItem("Device Config", "sub2"),
    getItem("Converters & Meters", "sub61"),
    // getItem("Groups", "sub6"),
    // getItem("Manual Entry", "sub3"),
    // getItem("Emission Factor", "sub4"),
    getItem("Dash Live ", "sub62"),
    getItem("Dash Energy ", "sub63"),
    getItem("Groups", "sub71"),
    // getItem("User Registration", "sub4"),
    getItem("Manual Entry", "sub13"),
    getItem("Application Settings", "sub91"),
    getItem("License Information", "sub92"),
  ]), 
  // getItem("Groups", "7", <AppstoreOutlined />,[
  // ]),
  getItem("Roles", "8", <BarChartOutlined />, [
    getItem("Roles", "sub81"),
    getItem("User Registration", "sub82"),
    getItem("Role Actions", "sub83"),
    // getItem("sub-group", "sub6"),
    // getItem("group-meter", "sub7"),
  ]),
//   getItem("Settings", "9", <SettingOutlined />, [
//   // getItem("License Details", "sub92"),
  
// ]),


//   getItem("SLD", "11", <AlertOutlined />, [
//   getItem("SLD", "sub111"),
//   getItem("SLD Configuration", "sub112"),
  
// ]),
];

export const ElectricalNavItems = [
    { path: "/electrical-dashboard/shift-report", id: "sub51",screenName:"CONVERTERS & METERS"  },
    { path: "/electrical-dashboard/license-details", id: "sub92",screenName:"CONVERTERS & METERS"  },
    { path: "/electrical-dashboard/converters-meters", id: "sub61",screenName:"CONVERTERS & METERS"  },
  { path: "/electrical-dashboard/configuration-groups", id: "sub71",screenName:"Groups"  },
  { path: "/electrical-dashboard/configuration-live", id: "sub62",screenName:"Dash Live"  },
  { path: "/electrical-dashboard/configuration-energy", id: "sub63",screenName:"Dash Energy"  },
  // { path: "/configuration-dashboard/Group-config/group", id: "sub5",screenName:"Alerts"  },
  { path: "/electrical-dashboard/configuration-roles", id: "sub81",screenName:"Roles"  },
  { path: "/electrical-dashboard/configuration-user-registration", id: "sub82",screenName:"User Registration"  },
  { path: "/electrical-dashboard/configuration-screens", id: "sub83",screenName:"Role actions"  },


  { path: "/electrical-dashboard/settings", id: "sub91",screenName:"Settings" }, 
  { path: "/electrical-dashboard/License-information", id: "sub92",screenName:"License Information" }, 

  // { path: "/electrical-dashboard/tree-chart", id: "1" },
  { path: "/electrical-dashboard/alerts", id: "sub101",screenName:"Alerts" },
  { path: "/electrical-dashboard/meter-alert-configration", id: "sub102",screenName:"Meter Alert Configuration" },
  { path: "/electrical-dashboard/manual", id: "sub13",screenName:"" ,screenName:"Manual Configuration"},
  { path: "/electrical-dashboard/manual-entry-data", id: "sub14" ,screenName:"Manual Entry"},
  { path: "/electrical-dashboard/status-view", id: "sub15" ,screenName:"Status View"},
  { path: "/electrical-dashboard/plot-interval", id: "sub16" ,screenName:"Plot Report"},

  { path: "/electrical-dashboard/livemodule-chart", id: "2" ,screenName:"Live-trends"},
  { path: "/electrical-dashboard/live-trends", id: "sub1" ,screenName:"Live trends"},
  { path: "/electrical-dashboard/meter-status", id: "sub2" ,screenName:"Meter Status"},
  { path: "/electrical-dashboard/parameter-view", id: "sub3" ,screenName:"Parameter View"},
  { path: "/electrical-dashboard/dashboard", id: "sub18",screenName:"Dashboard" }, 
  // { path: "/electrical-dashboard/plant-form", id: "4" },
  { path: "/electrical-dashboard/comparative-report", id: "sub4",screenName:"Comparative Report" },
  { path: "/electrical-dashboard/raw-data", id: "sub5",screenName:"Raw Data" },
  { path: "/electrical-dashboard/historical-trends", id: "sub6",screenName:"Historical Trends" },
  { path: "/electrical-dashboard/consumption-report", id: "sub7",screenName:"Consumption Report" },

  { path: "/electrical-dashboard/groups", id: "sub8",screenName:"" },
  { path: "/electrical-dashboard/sub-group", id: "sub9",screenName:"" },
  { path: "/electrical-dashboard/group-config", id: "sub10",screenName:"" },
  { path: "/electrical-dashboard/group-report", id: "sub11",screenName:"" },
  { path: "/electrical-dashboard/sld", id: "sub111",screenName:"Consumption Report" },
  { path: "/electrical-dashboard/sld-config", id: "sub112",screenName:"Consumption Report" },
  // { path: "http://localhost:81", id: "sub121",screenName:"Consumption Report" },
  { path: "/electrical-dashboard/power-interruption-report", id: "sub12",screenName:"Consumption Report" },
  // { path: "https://che-emsflow.eu.nemak.net", id: "sub121",screenName:"Consumption Report" },
  { path: "https://wegindiaapp.minnotra.in", id: "sub121",screenName:"Consumption Report" },
  // { path: "https://chedsk0053.eu.nemak.net:448", id: "sub121",screenName:"Consumption Report" },
];

// https://chedsk0053.eu.nemak.net:448/#/dashboard/live-trends

export const WaterItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("PlantForm", "4", <BankOutlined />),
  getItem("LiveModule", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Convertor Status", "sub3"),
  ]),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption Report", "sub7"),
  ]),
];

export const WaterNavItems = [
  // { path: "/water-dashboard/tree-chart", id: "1" },
  // { path: "/water-dashboard/plant-form", id: "4" },
  { path: "/water-dashboard/water-live-trends", id: "sub1" },
  { path: "/water-dashboard/meter-status", id: "sub2" },
  { path: "/water-dashboard/water-convertor-status", id: "sub3" },
  { path: "/water-dashboard/water-comparative-report", id: "sub4" },
  { path: "/water-dashboard/water-raw-data", id: "sub5" },
  { path: "/water-dashboard/water-historical-trends", id: "sub6" },
  { path: "/water-dashboard/water-consumption-report", id: "sub7" },
];

export const SteamItems = [
  // getItem("Dashboard", "1",<CloudDownloadOutlined />),
  getItem("LiveModule", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Convertor Status", "sub3"),
  ]),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption Report", "sub7"),
  ]),
];

export const SteamNavItems = [
  // { path: "/steam-dashboard/tree-chart", id: "1" },
  { path: "/steam-dashboard/steam-live-trends", id: "sub1" },
  { path: "/steam-dashboard/meter-status", id: "sub2" },
  { path: "/steam-dashboard/steam-convertor-status", id: "sub3" },
  { path: "/steam-dashboard/comparative-report", id: "sub4" },
  { path: "/steam-dashboard/raw-data", id: "sub5" },
  { path: "/steam-dashboard/historical-trends", id: "sub6" },
  { path: "/steam-dashboard/consumption-report", id: "sub7" },
];

export const ConfigurationItems = [
  getItem("Configuration", "1", <SettingOutlined />, [
    // getItem("Converter Config", "sub1"),
    // getItem("Device Config", "sub2"),
    getItem("Converters & Meters", "sub7"),
    // getItem("Groups", "sub6"),
    // getItem("Manual Entry", "sub3"),
    // getItem("Emission Factor", "sub4"),
    getItem("Dash Live ", "sub8"),
    getItem("Dash Energy ", "sub9"),
    // getItem("User Registration", "sub4"),
  ]),
    getItem("Groups", "4", <AppstoreOutlined />,[
     getItem("Groups", "sub6"),
  ]),
  getItem("Roles", "2", <BarChartOutlined />, [
    getItem("Roles", "sub10"),
    getItem("User Registration", "sub11"),
    getItem("Role Actions", "sub12"),
    // getItem("sub-group", "sub6"),
    // getItem("group-meter", "sub7"),
  ]),
  // getItem("Group Configuration", "2", <SettingOutlined />, [
  //   getItem("group", "sub5"),
  //   getItem("sub-group", "sub6"),
  //   getItem("group-meter", "sub7"), 
  // ]),
];

export const ConfigurationNavItems = [
  { path: "/configuration-dashboard/Converter-config", id: "sub1",screenName:"Alerts"  },
  { path: "/configuration-dashboard/Device-config", id: "sub2",screenName:"Alerts"  },
  { path: "/configuration-dashboard/Manual-Entry", id: "sub3",screenName:"Alerts"  },
  // { path: "/configuration-dashboard/Application-Config", id: "sub3" },
  { path: "/configuration-dashboard/Emission-Factor", id: "sub4",screenName:"Alerts"  },
  { path: "/configuration-dashboard/converters-meters", id: "sub7",screenName:"ConverterAndMeters"  },
  { path: "/configuration-dashboard/configuration-groups", id: "sub6",screenName:"Groups"  },
  { path: "/configuration-dashboard/configuration-live", id: "sub8",screenName:"DashLive"  },
  { path: "/configuration-dashboard/configuration-energy", id: "sub9",screenName:"DashEnergy"  },
  { path: "/configuration-dashboard/Group-config/group", id: "sub5",screenName:"Alerts"  },
  { path: "/configuration-dashboard/configuration-roles", id: "sub10",screenName:"Roles"  },
  { path: "/configuration-dashboard/configuration-user-registration", id: "sub11",screenName:"User Registration"  },
  { path: "/configuration-dashboard/configuration-screens", id: "sub12",screenName:"Role actions"  },
  // { path: "/configuration-dashboard/Group-config/sub-group", id: "sub6" },
  // { path: "/configuration-dashboard/Group-config/group-meter", id: "sub7" },

  // { path: "/configuration-dashboard/Steam-grouping/group", id: "sub8" },
  // { path: "/configuration-dashboard/Steam-grouping/sub-group", id: "sub9" },
  // { path: "/configuration-dashboard/Steam-grouping/group-meter", id: "sub10" },
  // { path: "/configuration-dashboard/Water-grouping/group", id: "sub11" },
  // { path: "/configuration-dashboard/Water-grouping/sub-group", id: "sub12" },
  // { path: "/configuration-dashboard/Water-grouping/group-meter", id: "sub13" },
];
